module.exports = __webpack_public_path__ + "font/65b286af.ttf";